import { h } from "preact";
import { Link } from "preact-router";
import { publicPath } from "../../config";
import Logo from "../../assets/logo.png";
import style from "./style.css";
import { useState, useEffect } from "preact/hooks";
import { getPayoffInfo } from "../../api";

const Header = () => {
  const [spotName, setSpotName] = useState();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const {
          data: { spot_name: spotName },
        } = await getPayoffInfo();
        setSpotName(spotName);
      } catch {}
    };
    fetchData();
  }, []);

  return (
    <nav className={`${style.header} navbar`}>
      {/* <div className="navbar-brand"> */}
      {/* <img
        src="https://bulma.io/images/ -logo.png"
        width="112"
        height="28"
      /> */}
      <Link href={`${publicPath}/`} className={style.wrapper}>
        <img src={Logo} className={style.logo} alt="logo" />
        <span className={`${style.brand} title is-3`}>{spotName}</span>
      </Link>
      {/* </div> */}
    </nav>
  );
};

export default Header;
